<template>
  <v-container grid-list-lg class="ma-0 pa-0" fluid>
    <v-layout row wrap>
      <v-flex xs12 md6>
        <v-card>
          <v-card-title>
            <span class="title">Change approval user information</span>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>

            <v-form @submit.prevent="formSubmit" ref="form">
              <v-layout row wrap>
                <v-flex xs5 offset-xs3 md3 offset-md5>
                  <v-avatar size="128">
                    <img :src="imagePath" width="128">
                  </v-avatar>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="approver.employee_id" label="Employee ID" :error-messages="errors.collect('employee id')" v-validate="'required'"
                    data-vv-name="employee id" required></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="approver.salutation" label="Salutation" :error-messages="errors.collect('salutation')" v-validate="'required'"
                    data-vv-name="salutation" required></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="approver.first_name" label="First name" :error-messages="errors.collect('first name')" v-validate="'required'"
                    data-vv-name="first name" required></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="approver.last_name" label="Last name" :error-messages="errors.collect('last name')" v-validate="'required'"
                    data-vv-name="last name" required></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select v-bind:items="getAllRanks" v-model="approver.rank_id" label="Release code" item-value="id" :error-messages="errors.collect('rank')"
                    v-validate="'required'" data-vv-name="rank" required>
                    <template slot="selection" slot-scope="data">
                      {{ data.item.rank_initial }} - {{ data.item.description }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.rank_initial }} - {{ data.item.description }}
                    </template>
                  </v-select>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="approver.email" label="E-mail" :error-messages="errors.collect('email')" v-validate="'required|email'"
                    data-vv-name="email" required></v-text-field>
                </v-flex>
                <v-flex xs12>
                <v-select
                  :items="getAllCompanies"
                  v-model="approver.company_code"
                  item-value="company_code"
                  item-text="description"
                  label="Company code"
                  multiple
                  chips
                  v-validate="'required'" 
                  hint="Choose one or more company code"
                  persistent-hint
                  :error-messages="errors.collect('company_code')" 
                  data-vv-name="company_code"
                  required
                ></v-select>
              </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="accent" @click="editApproverPasswordById(id)">change password</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="onFormApprovalUserSubmit" dark color="accent" :loading="getLoading" :disable="getLoading">save
            </v-btn>
            <v-btn @click="clear()" color="secondary">clear</v-btn>
            <v-btn to="/approver">cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12 md6>
        <v-card>
          <v-card-title>
            <span class="title">Change user's devices</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-data-table v-if="!getLoading" loading="true" v-bind:headers="headers" v-bind:items="getUserNotNullDevices" v-bind:search="search"
              v-model="selected" item-key="id" class="elevation-0">
              <template slot="headerCell" slot-scope="props">
                <span>
                  {{ props.header.text }}
                </span>
              </template>
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">

                  <v-tooltip bottom v-if="props.item.is_blocked === 0">
                    <v-btn flat icon @click="setDeviceStatus(props.item.id, props.item.is_blocked)" color="red" slot="activator">
                      <v-icon>block</v-icon>
                    </v-btn>
                    <span>Deactivate</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="props.item.is_blocked === 1">
                    <v-btn flat icon @click="setDeviceStatus(props.item.id, props.item.is_blocked)" color="primary" slot="activator">
                      <v-icon>check_circle</v-icon>
                    </v-btn>
                    <span>Activate</span>
                  </v-tooltip>
                </td>
                <td class="text-xs-left">{{ props.item.device_name}}</td>
                <td class="text-xs-left">{{ props.item.device_os}}</td>
                <!-- <td class="text-xs-left">{{ props.item.device_uuid}}</td> -->
                <td class="text-xs-left">{{ props.item.device_version}}</td>
                <td class="text-xs-left">{{ props.item.is_blocked === 1 ? `Inactive` : `Activate`}}</td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-snackbar :color="color" :timeout="timeout" bottom right v-model="snackbar">
        {{ text }}
        <v-btn flat dark @click.native="snackbar = false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { httpInstance as axios } from '../../api'

export default {
  name: 'change-approver',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      id: this.$route.params.id,
      // imagePath: `${axios.defaults.baseURL}${
      //   this.$store.state.workflow.activeApprovalUser.small_photo
      // }`,
      approver: {},
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: '',
      search: '',
      selected: [],
      headers: [
        {
          text: 'Actions',
          align: 'left',
          value: 'actions',
          sortable: false
        },
        {
          text: 'Device Name',
          align: 'left',
          value: 'device_name'
        },
        {
          text: 'OS',
          align: 'left',
          value: 'device_os'
        },
        // {
        //   text: 'UUID',
        //   align: 'left',
        //   value: 'device_uuid'
        // },
        {
          text: 'Version',
          align: 'left',
          value: 'device_version'
        },
        {
          text: 'Status',
          align: 'left',
          value: 'status'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getLoading',
      'getResponse',
      'getAllRanks',
      'getActiveApprovalUser',
      'getUserDevices',
      'getUserNotNullDevices',
      'getAllCompanies'
    ]),
    imagePath () {
      return `${axios.defaults.baseURL}${
        this.$store.state.workflow.activeApprovalUser.small_photo
      }`
    }
  },
  methods: {
    ...mapActions([
      'fetchAllRanks',
      'setActiveApprovalUser',
      'changeApprovalUser',
      'fetchUserDevices',
      'blockUserDevice',
      'fetchAllCompanies'
    ]),
    editApproverPasswordById (id) {
      this.$router.push({ name: 'ChangeApproverPassword', params: { id: id } })
    },

    clear () {
      this.$refs.form.reset()
      this.$validator.reset()
    },

    onFormApprovalUserSubmit: function () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.changeApprovalUser(this.approver).then(() => {
            let response = this.getResponse
            this.snackbar = true
            this.text =
              response.status === 200
                ? 'Changed successfully.'
                : response.data.message
            this.color = response.status === 200 ? 'success' : 'error'
          })
        }
      })
    },
    setDeviceStatus (_id, _status) {
      let status = _status === 1 ? 0 : 1
      this.blockUserDevice({ id: _id, is_blocked: status }).then(() => {
        // do nothing
      })
    }
  },
  mounted: function () {
    this.fetchAllRanks()
    this.fetchAllCompanies()

    this.setActiveApprovalUser(this.id)
      .then(() => {
        this.approver = Object.assign({}, this.getActiveApprovalUser)
        // this.imagePath = `${axios.defaults.baseURL}${
        //   this.$store.state.workflow.activeApprovalUser.small_photo
        // }`
      })
      .catch(error => {
        console.log(error)
      })
    this.fetchUserDevices(this.id).then(() => {
      //  do nothing
    })
  }
}
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile-user/ChangeApprover.vue